import React, { useEffect } from 'react'
import './leaderboard.css';
import Tilt from 'react-parallax-tilt';

import LeaderData from '../helper/LeaderData';

const leaderboard = () => {
    return (
        <>
            <div className="container hero-leader">
                <div className="lead-title">
                    <h2>Leader Board</h2>
                    <p>Top On Leaderboard This Week</p>
                </div>
                <div className="container featured">
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 featured-card">
                        {
                            LeaderData.map((value, index) => (
                                <Tilt style={{ margin: "0 auto" }}>
                                    <div className="col-md lead-card" key={index}>
                                        <div className="card-rank">
                                            <h1>{value.rank}</h1>
                                        </div>
                                        <div className="lead-card-img">
                                            <img src={value.img} alt="" />
                                        </div>
                                        <div className="card-title lead-name">
                                            <p>{value.name}</p>
                                        </div>
                                        <div className="card-desc">
                                            <p>{value.desc}</p>
                                        </div>
                                    </div>
                                </Tilt>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}


export default leaderboard
